import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { GeoJSON } from 'react-leaflet';

import { PROPERTY_TYPES } from '../../../constants';
import { getPropertyImages } from '../../../utils/attachmentUtils';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import withSize from '../../WithSize/WithSize';
import Tab from './Tab';
import List from '../../List/List';
import MapWrapper from '../../Map/MapWrapper';
import AppliedSearch from '../../AppliedSearch/AppliedSearch';
import MapToolbarWrapper from '../../MapToolbar/MapToolbarWrapper';
import ShapeError from '../../ShapeError/ShapeError';

import PropertyDetailWrapper from '../../PropertyDetail/PropertyDetailWrapper';
import PropertyFilterWrapper from '../PropertyFilter/PropertyFilterWrapper';
import ReportsModal from '../../ReportsModal/ReportsModal';
import WorkforceReportsModal from '../../WorkforceReportsModal/WorkforceReportsModal';
import FoldersModal from '../../Favorites/FoldersModal';
import FirstTimeFavoriteModal from '../../Favorites/FirstTimeFavoriteModal';
import SlideshowModal from '../../Modal/SlideshowModal/SlideshowModal';

import PropertyFilters from '../PropertyFilters';
import withAppliedFilters from '../../Filter/WithAppliedFilters';
import withLazy from '../../WithLazy/WithLazy';
import { fetchBuildings, fetchSites, setActiveTab,
  updateProperties, fetchPropertyFilterValues } from '../../../store/actions';

import './PropertyWrapper.css';

export class PropertyWrapperComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalType: null,
      modalProperties: [],
      modalPropertyType: null,
      modalAction: null,
      filterValuesFetched: false,
    };

    this.onTabChange = this.onTabChange.bind(this);
    this.setModalInfo = this.setModalInfo.bind(this);
    this.setModalType = this.setModalType.bind(this);
  }

  componentWillReceiveProps({ openModal }) {
    if (!openModal) {
      this.setState(prevState => ({
        ...prevState,
        modalType: null,
      }));
    }
    const {
      getFilterValues,
      organizationId,
      filterValues,
    } = this.props;

    // This request is cheap so just getting all for now
    const hasFilters = Object.keys(filterValues).length !== 0;
    if (!hasFilters && !this.state.filterValuesFetched) {
      getFilterValues(organizationId);
      this.setState({ filterValuesFetched: true });
    }
  }

  onTabChange(e) {
    const { value: activeTab } = e.currentTarget;
    const { handleTabChange, pathname } = this.props;

    handleTabChange(activeTab, pathname);
  }

  setModalInfo({ properties, propertyType, type, action }) {
    this.setState(prevState => ({
      ...prevState,
      modalProperties: properties,
      modalPropertyType: propertyType,
      modalType: type,
      modalAction: action,
    }));
  }

  setModalType(type) {
    this.setState(prevState => ({
      ...prevState,
      modalType: type,
    }));
  }

  render() {
    const {
      activeTab,
      activeProperty,
      activeColor,
      additionalSort,
      detailProperty,
      filters,
      isMobile,
      items,
      layers,
      onSortClick,
      organizationId,
      propertyType,
      showMore,
      sortType,
      total,
      loading,
      showSearchAndAppliedFilters,
      match,
      filterValues,
      shapeError,
      suppressWarnings,
      listLoading,
    } = this.props;
    const images = activeProperty ? getPropertyImages(detailProperty, propertyType) : [];
    const showFoldersModal = this.state.modalProperties.length > 0 && this.state.modalType === 'folders';
    const showNotLoggedIntoFavoritesModal = this.state.modalProperties.length > 0 && this.state.modalType === 'first-time';
    const showModalTitle = propertyType === PROPERTY_TYPES.BUILDINGS ? 'Building Images' : 'Site Images';
    const areaPolygon = (filters.get('area'))
      ? [(
        <GeoJSON
          key={0}
          data={filters.get('area').polygon}
          style={{
            color: activeColor,
            weight: 2,
            fillOpacity: 0,
          }}
        />
        )]
      : null;

    return (
      <div className={`content-wrapper ${isMobile ? 'layout--mobile' : ''} ${activeTab ? `layout--${activeTab}` : ''}`}>
        {this.state.modalProperties.length === 1 && this.state.modalType === 'report' &&
          <ReportsModal
            property={this.state.modalProperties[0]}
          />
        }
        {this.state.modalProperties.length === 1 && this.state.modalType === 'workforce-report' &&
          <WorkforceReportsModal
            property={this.state.modalProperties[0]}
          />
        }
        {showFoldersModal && (
          <FoldersModal
            items={this.state.modalProperties}
            itemType={this.state.modalPropertyType}
            action={this.state.modalAction}
          />
        )}
        {showNotLoggedIntoFavoritesModal && (
          <FirstTimeFavoriteModal
            items={this.state.modalProperties}
            itemType={this.state.modalPropertyType}
            action={this.state.modalAction}
            onContinue={() => this.setModalType('folders')}
          />
        )}
        {items && items.length > 0 && isMobile && activeTab === 'tab-search' && (
          <div className="properties-search-container">
            <PropertyFilterWrapper
              filterValues={filterValues}
              isMobile={isMobile}
              propertyType={propertyType}
              organizationId={organizationId}
            />
          </div>
        )}
        {(!isMobile || activeTab === 'tab-list') && (
          <List
            addMoreViewable={showMore}
            total={total}
            properties={items}
            type={propertyType}
            sortType={sortType}
            handleSort={onSortClick}
            additionalSort={additionalSort}
            handleModalOpen={this.setModalInfo}
            isMobile={isMobile}
            loading={loading}
            listLoading={listLoading}
          />
        )}
        {isMobile && activeTab === 'tab-detail' && (
          <Route
            path={`${match.url}/:propertyId/:subTab?`}
            render={props => (
              <div className="properties-search-container">
                <PropertyDetailWrapper
                  {...props}
                  type={propertyType}
                  isMobile={isMobile}
                  handleModalOpen={this.setModalInfo}
                />
              </div>
            )}
          />
        )}
        {(!isMobile || activeTab === 'tab-map') && (
          <MapWrapper
            properties={items}
            type={propertyType}
            layers={layers}
            polygons={areaPolygon}
            appliedSearchOpen={filters.size > 0 && showSearchAndAppliedFilters}
            handleModalOpen={this.setModalInfo}
          >
            {!isMobile && (
              <Route
                path={`${match.url}/:propertyId/:subTab?`}
                render={props => (
                  <div className="properties-search-container">
                    <PropertyDetailWrapper
                      {...props}
                      type={propertyType}
                      isMobile={isMobile}
                      handleModalOpen={this.setModalInfo}
                    />
                  </div>
                )}
              />
            )}
            <MapToolbarWrapper type={propertyType} toolsActive />
            {showSearchAndAppliedFilters && (
              <AppliedSearch
                filterValues={filterValues}
                filters={filters}
                propertyType={propertyType}
              />)
            }
            {shapeError !== '' && !suppressWarnings && <ShapeError />}
          </MapWrapper>
        )}
        <div className="tabs">
          <ViewerPrimaryColorUserStyle domStyle="borderColor">
            <div className="tabs__tab-bar">
              <Tab
                name="activePropertyTab"
                value="tab-search"
                checked={activeTab === 'tab-search'}
                onChange={this.onTabChange}
                label="Search"
              />
              <Tab
                name="activePropertyTab"
                value="tab-list"
                checked={activeTab === 'tab-list'}
                onChange={this.onTabChange}
                label="List"
              />
              <Tab
                name="activePropertyTab"
                value="tab-detail"
                checked={activeTab === 'tab-detail'}
                onChange={this.onTabChange}
                label="Detail"
              />
              <Tab
                name="activePropertyTab"
                value="tab-map"
                checked={activeTab === 'tab-map'}
                onChange={this.onTabChange}
                label="Map"
              />
            </div>
          </ViewerPrimaryColorUserStyle>
        </div>
        {activeProperty && (
          <SlideshowModal
            id={detailProperty._id}
            property={detailProperty}
            modalTitle={showModalTitle}
            images={images}
          />
        )}
      </div>
    );
  }
}

export function getMatchingRouteParam(ownProps) {
  const { match: { params: { propertyType } } } = ownProps;
  const isBuildings = propertyType === PROPERTY_TYPES.BUILDINGS;

  const additionalSort = isBuildings ? 'sqft' : 'acres';
  const fetcher = isBuildings ? fetchBuildings : fetchSites;
  const filterGroup = PropertyFilters[propertyType];

  return {
    additionalSort,
    propertyType,
    fetcher,
    filterGroup,
  };
}

export function hasActiveProperty(state, propertyType) {
  return !!(state[propertyType] && state[propertyType].active && state[propertyType].active._id);
}

export const mapStateToProps = (state, { propertyType }) => {
  return ({
    activeColor: state.viewer.activeColor,
    activeTab: state[propertyType].activeTab,
    activeProperty: hasActiveProperty(state, propertyType),
    detailProperty: state[propertyType].active,
    fetched: state[propertyType].items.length > 0,
    filters: state[propertyType].filters,
    items: state[propertyType].items,
    organizationId: state.organizationId,
    layers: state[propertyType].mapLayers,
    pagination: state[propertyType].pagination,
    pathname: state.router.location.pathname,
    sort: state[propertyType].sort,
    sortType: state[propertyType].sort.join(' '),
    openModal: !!state.modal,
    showSearchAndAppliedFilters: state.viewer.showSearchAndAppliedFilters,
    filterValues: state[propertyType].filterValues,
    shapeError: state.viewer.shapeError,
    suppressWarnings: state.viewer.suppressWarnings,
    listLoading: state.listLoading,
  });
};

/* istanbul ignore next */
export const mapDispatchToProps = (dispatch, { propertyType }) => {
  return {
    onSortClick: (filters, organizationId) => sort => dispatch(
      updateProperties(propertyType, filters, sort, organizationId),
    ),
    handleTabChange: activeTab => dispatch(setActiveTab(propertyType, activeTab)),
    setProperties: organizationId => (filters, sort, page) => {
      dispatch(updateProperties(propertyType, filters, sort, organizationId, page));
    },
    getFilterValues: async organizationId => {
      const filters = await dispatch(fetchPropertyFilterValues(organizationId, propertyType));
      return filters;
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { filters, organizationId } = stateProps;
  const { setProperties, onSortClick } = dispatchProps;
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    setProperties: setProperties(organizationId),
    onSortClick: onSortClick(filters, organizationId),
  };
};

export const withPropsProxy = WrappedComponent => props => (
  <WrappedComponent
    {...props}
    // allows the use of propertyType to pull from PropertyFilters constants
    {...getMatchingRouteParam(props)}
  />
);

PropertyWrapperComponent.propTypes = {
  activeColor: PropTypes.string,
  activeProperty: PropTypes.bool,
  activeTab: PropTypes.string,
  additionalSort: PropTypes.string,
  detailProperty: PropTypes.object,
  filters: PropTypes.object.isRequired,
  handleTabChange: PropTypes.func,
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired).isRequired,
  loading: PropTypes.bool,
  layers: PropTypes.object,
  total: PropTypes.number,
  organizationId: PropTypes.string.isRequired,
  onSortClick: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  propertyType: PropTypes.string.isRequired, // passed in from the URL / MapViewer.js
  showMore: PropTypes.func,
  sortType: PropTypes.string.isRequired,
  showSearchAndAppliedFilters: PropTypes.bool,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  filterValues: PropTypes.object,
  getFilterValues: PropTypes.func,
  shapeError: PropTypes.string,
  suppressWarnings: PropTypes.bool,
  listLoading: PropTypes.bool,
};

export default withPropsProxy(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(
    withAppliedFilters(
      withLazy(
        withSize(
          PropertyWrapperComponent,
        ),
      ),
    ),
  ),
);



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyWrapper/PropertyWrapper.js